import { useEffect, useRef, useState } from 'react'

// TODO: Change this to proper typescript
const useIntersect = (
  root: Element | Document | null = null,
  rootMargin = '0px',
  threshold = 0,
  initialState = false,
  shouldDisconnect = false,
): [(el: HTMLElement | null) => void, boolean, Element | Document | null] => {
  const [isIntersecting, setIsIntersecting] = useState(initialState)
  const [node, setNode] = useState<HTMLElement | null>(null)

  const ref = (el: HTMLElement | null) => {
    if (el !== null) {
      setNode(el)
    }
  }

  const options = {
    root,
    rootMargin,
    threshold,
  }

  function callback(entries: any[]) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsIntersecting(true)
      } else {
        setIsIntersecting(false)
      }
    })
  }

  const observer = useRef(
    typeof window !== 'undefined' && window.IntersectionObserver && new window.IntersectionObserver(callback, options),
  )

  useEffect(() => {
    if (shouldDisconnect) {
      return
    }
    const { current: currentObserver } = observer
    if (currentObserver) {
      currentObserver.disconnect()

      if (node) currentObserver.observe(node)

      return () => {
        currentObserver.disconnect()
      }
    }
    return
  }, [node, observer, shouldDisconnect])

  return [ref, isIntersecting, node]
}

export default useIntersect
